import { Avatar,Button } from '@mui/material';
import React, { useState } from 'react';
import './TweetBox.css';
import db from './firebase';

function TweetBox() {
  const [tweetMessage, setTweetMessage] = useState("");
  const [tweetImage, setTweetImage] = useState("");

  const sendTweet = (e) => {
    e.preventDefault();

    db.collection("posts").add({
      displayName: "Aditya Tomar",
      username: "adityatomar_16",
      verified: true,
      text: tweetMessage,
      image: tweetImage,
      avatar:
        "https://media.comicbook.com/2019/07/one-piece-wano-anime-luffy-1178436.jpeg?auto=webp&width=1200&height=672&crop=1200:672,smart"});

    setTweetMessage("");
    setTweetImage("");
  };

  return (
    <div className="tweetbox">
      <form>
        <div className="tweetbox_input">
          <Avatar src="https://media.comicbook.com/2019/07/one-piece-wano-anime-luffy-1178436.jpeg?auto=webp&width=1200&height=672&crop=1200:672,smart" />
          <input
            onChange={(e) => setTweetMessage(e.target.value)}
            value={tweetMessage}
            placeholder="What's happening?"
            type="text"
          />
        </div>
        <input
          value={tweetImage}
          onChange={(e) => setTweetImage(e.target.value)}
          className="tweetbox_inputImage"
          placeholder="Optional: Enter image URL"
          type="text"
        />

        <Button
          onClick={sendTweet}
          type="submit"
          className="tweetbox_tweetButton"
        >
          Tweet
        </Button>
      </form>
    </div>
  );
}

export default TweetBox;